export const removeMultipleDots = (value: string) => value.match(/\d*\.?\d*/)?.[0] ?? '';
